module.exports = __webpack_public_path__ + "img/safety-pharm-box.b4a1802f.png";